"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M5.5 13.1057H8v-1.9743H4.5c-.2761 0-.5-.221-.5-.4936 0-.2726.2239-.4936.5-.4936H8V8.1699H5.5c-.2761 0-.5-.221-.5-.4936 0-.2726.2239-.4936.5-.4936H8V5.2083H6.0277c.0346-.2208.1039-.4118.2368-.5737.2015-.2452.7583-.6603 2.3874-.6603 2.0866 0 3.6156.3371 6.3316 1.1598 2.6156.7922 4.2544 1.237 6.0165 1.2747V4.434c-1.4264-.0366-2.8161-.3958-5.4298-1.1875C12.7862 2.4033 11.034 2 8.6519 2 6.7184 2 5.447 2.495 4.711 3.3912c-.695.8462-.7149 1.8321-.7154 2.3138C3.391 6.1554 3 6.8708 3 7.6763c0 .3086.0574.604.1622.8763C2.4636 8.9902 2 9.7606 2 10.6378s.4636 1.6475 1.1622 2.0852A2.4343 2.4343 0 0 0 3 13.5993c0 1.363 1.1193 2.4679 2.5 2.4679h4.8026c-.2946.9793-.5435 1.9723-.7523 2.9733-.273 1.3194.577 2.6145 1.9136 2.9041 1.3373.2897 2.5559-.5904 2.9702-1.8438.1403-.4245 1.0034-2.8805 2.3875-4.3481C17.9191 14.589 19.445 13.9123 21 13.719v-1.9864c-2.043.2006-4.1226 1.0635-5.6422 2.6748-1.7168 1.8203-2.6879 4.6659-2.8251 5.081-.0894.2706-.3136.5984-.6401.5277-.2955-.064-.4312-.3475-.3733-.626.0439-.2159.4533-2.1868 1.1008-3.9783l.4767-1.3189H5.5c-.2761 0-.5-.221-.5-.4936 0-.2726.2239-.4936.5-.4936z"
  })];
};

exports.default = _default;